import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { BaseFont } from './styles';

export const TypographyComponent = ({
  className,
  styles,
  align,
  children,
  component,
  variant,
  weight,
  color,
  ...rest
}) => {
  const classNames = {};
  classNames[`nmx-${variant}`] = variant;
  classNames[`nmx-${color}`] = color;
  classNames[`nmx-align-${align}`] = align && align !== 'inherit';
  classNames[className] = className;
  return (
    <BaseFont
      className={classnames(classNames, className)}
      as={component || 'p'}
      weight={weight}
      {...rest}
      style={styles || {}}>
      {children}
    </BaseFont>
  );
};

TypographyComponent.propTypes = {
  /** Custom class name to add to Type. */
  className: PropTypes.string,
  styles: PropTypes.object,
  /** Alignment for text component */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right']),
  /** The inner content to be rendered */
  children: PropTypes.node.isRequired,
  /** what the DOM element rendered should be */
  component: PropTypes.oneOf([
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'span',
    'div',
  ]),
  /** What styled should be applied to the tag */
  variant: PropTypes.oneOf(['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  /** allows overriding of font-weight */
  weight: PropTypes.oneOf([100, 200, 300, 400, 500, 600, 700, 800, 900]), // TODO: name and export in a theme
  color: PropTypes.oneOf([
    'color-neutral-black',
    'color-neutral-white',
    'color-neutral-gray-29',
    'color-neutral-gray-23',
    'color-primary-nm-blue',
    'color-hero-text-stroke',
    'color-system-dark-red',
  ]),
};

TypographyComponent.defaultProps = {
  className: null,
  styles: null,
  component: 'p',
  color: 'color-neutral-black',
};

export default TypographyComponent;
